import { AuthInfo, AuthUser, TokenLoginInfo } from '@/types/User'
import { defineStore } from 'pinia'
import { UserApi } from '@/api/UserApi'
import { Permission, Role } from '@/types/Permissions'

interface AuthState {
  authInfo: AuthInfo | null
  tokenLoginInfo: TokenLoginInfo | null
}

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => {
    return {
      authInfo: null,
      tokenLoginInfo: null
    }
  },
  actions: {
    async setUser() {
      const api = new UserApi()

      this.authInfo = await api.getMe()
    },
    async setTokenLoginInfo(userId: number | null, accessToken: string | null) {
      this.tokenLoginInfo = {
        userId,
        accessToken
      }
    }
  },
  getters: {
    isAuth(): boolean {
      return this.authInfo ? true : false
    },
    user(): AuthUser | null {
      if (!this.authInfo) {
        return null
      }
      return this.authInfo.userInfo
    },
    permissions(): Permission[] {
      if (!this.authInfo) {
        return []
      }
      return this.authInfo.permissions
    },
    hasPermission: (state) => {
      return (permissionName: string) => {
        if (!state.authInfo?.permissions) {
          return false
        }

        return state.authInfo?.permissions.find(perm => perm.permission_name === permissionName) ? true : false
      }
    },
    role(): Role | null {
      if (!this.authInfo) {
        return null
      }
      return this.authInfo.role

    },
    isAdmin(): boolean {
      if (!this.authInfo) {
        return false
      }
      return this.authInfo.isAdminRole
    }
  }
})